function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1315",
  "data-name": "Group 1315",
  transform: "translate(-39.75 -212.105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1153",
  "data-name": "Group 1153",
  transform: "translate(118 -172)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_847",
  "data-name": "Group 847",
  transform: "translate(179.1 385.105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_682",
  "data-name": "Group 682",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M248.573-166.207c0-2.766-2.633-5.012-5.879-5.012H217.9c-3.244,0-5.879,2.246-5.879,5.012v32.061c0,2.766,2.634,5.012,5.879,5.012h24.792c3.245,0,5.879-2.246,5.879-5.012Z",
  transform: "translate(-212.024 176.964)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M220.819-172.8h22.574v-5.655H220.819Z",
  transform: "translate(-213.831 178.45)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M220.819-115.391h22.574v-1.415H220.819Z",
  transform: "translate(-213.831 165.447)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M212.168-162.192h36.321",
  transform: "translate(-212.054 175.023)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  "data-name": "Path 498",
  d: "M212.168-127.273h36.321",
  transform: "translate(-212.054 167.598)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_587",
  "data-name": "Path 587",
  d: "M231.682-149.994s3.972,6.111,3.972,8.3a3.974,3.974,0,0,1-3.972,3.972,3.975,3.975,0,0,1-3.973-3.972C227.709-143.883,231.682-149.994,231.682-149.994Z",
  transform: "translate(-213.407 171.015)",
  fill: "#48b05e",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_848",
  "data-name": "Group 848",
  transform: "translate(160 395.592)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678-2",
  "data-name": "Group 678",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486-2",
  "data-name": "Path 486",
  d: "M252.959-165.605c0-3.1-2.949-5.613-6.584-5.613H218.608c-3.634,0-6.584,2.515-6.584,5.613V-129.7c0,3.1,2.95,5.613,6.584,5.613h27.767c3.635,0,6.584-2.515,6.584-5.613Z",
  transform: "translate(-212.024 177.654)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489-2",
  "data-name": "Path 489",
  d: "M220.819-172.117H246.1v-6.333H220.819Z",
  transform: "translate(-212.992 178.45)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492-2",
  "data-name": "Path 492",
  d: "M220.819-115.221H246.1v-1.585H220.819Z",
  transform: "translate(-212.992 171.284)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495-2",
  "data-name": "Path 495",
  d: "M212.168-162.192h40.68",
  transform: "translate(-212.04 176.563)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498-2",
  "data-name": "Path 498",
  d: "M212.168-127.273h40.68",
  transform: "translate(-212.04 172.437)",
  fill: "#f5f5f5",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_678-3",
  "data-name": "Group 678",
  transform: "translate(167 218)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_486-3",
  "data-name": "Path 486",
  d: "M252.959-165.605c0-3.1-2.949-5.613-6.584-5.613H218.608c-3.634,0-6.584,2.515-6.584,5.613V-129.7c0,3.1,2.95,5.613,6.584,5.613h27.767c3.635,0,6.584-2.515,6.584-5.613Z",
  transform: "translate(-212.024 177.654)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489-3",
  "data-name": "Path 489",
  d: "M220.819-172.117H246.1v-6.333H220.819Z",
  transform: "translate(-212.992 178.45)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492-3",
  "data-name": "Path 492",
  d: "M220.819-115.221H246.1v-1.585H220.819Z",
  transform: "translate(-212.992 171.284)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495-3",
  "data-name": "Path 495",
  d: "M212.168-162.192h40.68",
  transform: "translate(-212.04 176.563)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498-3",
  "data-name": "Path 498",
  d: "M212.168-127.273h40.68",
  transform: "translate(-212.04 172.437)",
  fill: "#f5f5f5",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Component_34_83",
  "data-name": "Component 34 \\u2013 83",
  transform: "translate(251.509 253.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#48b05e",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Component_34_100",
  "data-name": "Component 34 \\u2013 100",
  transform: "translate(138.509 253.715) rotate(180)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10-2",
  "data-name": "Line 10",
  x1: 17.236,
  transform: "translate(0.273 7.218)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11-2",
  "data-name": "Line 11",
  x2: 7.218,
  y2: 7.218,
  transform: "translate(7.218) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12-2",
  "data-name": "Line 12",
  y1: 7.218,
  x2: 7.218,
  transform: "translate(7.218 7.218) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1179",
  "data-name": "Group 1179",
  transform: "translate(41 220)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_989",
  "data-name": "Group 989",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_599",
  "data-name": "Path 599",
  d: "M2.9-.305H26.3V-23.71H2.9Z",
  transform: "translate(-2.898 23.71)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_990",
  "data-name": "Group 990",
  transform: "translate(0 28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  d: "M2.9,13.131H26.3V-10.274H2.9Z",
  transform: "translate(-2.898 10.274)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_991",
  "data-name": "Group 991",
  transform: "translate(28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  d: "M17-.305H40.4V-23.71H17Z",
  transform: "translate(-16.995 23.71)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_604",
  "data-name": "Path 604",
  d: "M20.418-20.169h7.371",
  transform: "translate(-12.696 30.773)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_992",
  "data-name": "Group 992",
  transform: "translate(28.594 28.594)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  d: "M22.954-11.885h15.64V11.521H15.188V-.2H29.873",
  transform: "translate(-15.188 11.885)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1175",
  "data-name": "Group 1175",
  transform: "translate(5.173 43.062) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-2",
  "data-name": "Path 605",
  d: "M3.539,0h7.127V13.71H0V6.844H6.692",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1174",
  "data-name": "Group 1174",
  transform: "translate(34.721 5.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-3",
  "data-name": "Path 605",
  d: "M19.568-11.885h8.821V-.212h-13.2",
  transform: "translate(-15.188 11.885)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1177",
  "data-name": "Group 1177",
  transform: "translate(16.521 5.106) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605-4",
  "data-name": "Path 605",
  d: "M4.38,0H13.2V11.673H0",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_760",
  "data-name": "Path 760",
  d: "M0,0H14.341",
  transform: "translate(47.911 33.891) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_759",
  "data-name": "Path 759",
  d: "M6.32-6.733H21.2",
  transform: "translate(22.107 40.624)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_761",
  "data-name": "Path 761",
  d: "M20.418-20.169h5.544",
  transform: "translate(15.14 66.515)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1176",
  "data-name": "Group 1176",
  transform: "translate(5.136 48.169) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_762",
  "data-name": "Path 762",
  d: "M0,0H9.449",
  transform: "translate(0 0.001) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763",
  "data-name": "Path 763",
  d: "M0,0H4.814",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1178",
  "data-name": "Group 1178",
  transform: "translate(10.212 5.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_762-2",
  "data-name": "Path 762",
  d: "M0,0H8.3",
  transform: "translate(0 0.001) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763-2",
  "data-name": "Path 763",
  d: "M20.418-20.169h9.61",
  transform: "translate(-20.418 20.169)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}))));

var SvgAddNewCylinder = function SvgAddNewCylinder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294.899,
    height: 68.549,
    viewBox: "0 0 294.899 68.549",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddNewCylinder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-new-cylinder.214460be.svg";
export { ForwardRef as ReactComponent };